import { Component, OnInit } from '@angular/core';
import {
  trigger,
  transition,
  animate,
  style,
  sequence,
} from '@angular/animations';
import { DatePipe } from '@angular/common';
//import {SharedModule} from '../../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { NbCardModule } from '@nebular/theme';
import { MatTableModule } from '@angular/material/table';
@Component({
    selector: 'app-inspecciones-rowdetail',
    templateUrl: './inspecciones-rowdetail.component.html',
    styleUrls: ['./inspecciones-rowdetail.component.css'],
    animations: [
        trigger('rowsAnimation', [
            transition('void => *', [
                style({
                    height: '*',
                    opacity: '0',
                    transform: 'translateX(-550px)',
                    'box-shadow': 'none',
                }),
                sequence([
                    animate('.95s ease', style({
                        height: '*',
                        opacity: '.2',
                        transform: 'translateX(0)',
                        'box-shadow': 'none',
                    })),
                    animate('.95s ease', style({ height: '*', opacity: 1, transform: 'translateX(0)' })),
                ]),
            ]),
        ]),
    ],
    providers: [DatePipe],
    standalone: true,
    imports: [FormsModule,CommonModule,NbCardModule,NbIconModule,DropdownModule,MatTableModule],
})
export class InspeccionesRowdetailComponent implements OnInit {
  model: any;
  modelResponse: any;
  modelTransformed: any = [];
  columnsDef = [
    'AreaZonaCuadrante',
    'Tipo',
    'Severidad',
    'Observacion',
    'Responsable',
    'Clasificacion',
    'Codificacion',
  ];

  constructor() {}

  ngOnInit() {
    this.modelResponse = this.model.datosAverias;
    this.modelResponse.forEach((e) => {
      this.modelTransformed.push({
        AreaZonaCuadrante: e.areaZonaCuadrante,
        Tipo: e.tipo,
        Severidad: e.severidad,
        Observacion: e.observacion,
        Clasificacion: e.clasificacion,
        Codificacion: e.codificacion,
        Responsable: e.responsable,
      });
    });
  }
}
